export { default } from "./Select2V2";
